import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import {
    linkPurchaseOrder,
    LinkPurchaseOrderRequest,
    LinkPurchaseOrderResponse,
} from '../common/api/clients/mariapps.api';

export const useMariAppsLinkPurchaseOrder = () => {
    return useMutation<LinkPurchaseOrderResponse, AxiosError<{ error?: string }>, LinkPurchaseOrderRequest>({
        mutationFn: linkPurchaseOrder,
    });
};
